import React from 'react'

// Very simple component that receives two props:
// An image to display and isSelected to see if it's selected (styling purposes)

const Flag = ({ image, isSelected, alt, ...props }) => (
  <img width={30} height={30} alt={alt} src={image} className={isSelected ? 'flag selected' : 'flag'} {...props} />
)

export default Flag